import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const feasibilityAssessmentServices = {
  getFeasibilityAssessmentData,
  addNewFeasibilityAssessment,
  updateFeasibilityAssessmentData,
  softDeleteRestoreFeasibilityAssessment,
  deleteFeasibilityAssessmentData,
};

async function addNewFeasibilityAssessment(userData) {
  const response = await fetch(
    `${config.API_URL}addNewFeasibilityAssessment`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateFeasibilityAssessmentData(userData) {
  const response = await fetch(
    `${config.API_URL}updateFeasibilityAssessment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreFeasibilityAssessment(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreFeasibilityAssessment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteFeasibilityAssessmentData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteFeasibilityAssessmentData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getFeasibilityAssessmentData(status = "all", searchData = "", page, length, extraQuery = {}) {
  const query = new URLSearchParams();
  query.append("search", searchData || "");

  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  Object.entries(extraQuery || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const response = await fetch(
    `${config.API_URL}getFeasibilityAssessmentData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );

  const data = await response.json();
  return data;
}
